import { createFileRoute } from '@tanstack/react-router';

import { PublicChartPage } from '@/features/public-share/pages/PublicChartPage';

export const Route = createFileRoute('/s/$token')({
  component: PublicChartPage,
});
